<template lang="pug">
#medical-nursings-label.register-row
  .register-group
    .register-key
      span.key-name 医療・看護体制
    .register-value
      .d-flex.flex-column(v-if="_value")
        .d-flex.flex-row.flex-wrap.mb-2
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.nursingCareFood")
            span 介護食
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.liquidDysphagiaDiet")
            span 流動食・嚥下食
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.diabetesInsulin")
            span 糖尿病・インスリン
        .d-flex.flex-row.flex-wrap.mb-2
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.gastrostomy")
            span 胃ろう
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.nasogastricTube")
            span 鼻腔・経管栄養
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.stomaOrColostomy")
            span ストーマ・人工肛門
        .d-flex.flex-row.flex-wrap.mb-2
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.homeOxygenTherapy")
            span 在宅酸素療法
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.ventilator")
            span 人工呼吸器
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.bedsore")
            span 褥瘡・床ずれ
        .d-flex.flex-row.flex-wrap.mb-2
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.phlegmSuction")
            span たん吸引
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.dialysis")
            span 人工透析
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.tracheostomy")
            span 気管切開
        .d-flex.flex-row.flex-wrap.mb-2
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.totalParenteralNutrition")
            span 中心静脈栄養
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.urinaryCatheterOrBalloonCatheter")
            span カテーテル・尿バルーン
          .medical-nursing-label.d-flex.flex-row.align-items-center
            FacilityAcceptMark(:value="_value.pacemaker")
            span ペースメーカー
      .d-flex.flex-column(v-else)
        .error-message 未設定
      
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import { MedicalNursings } from "@/commons/services/Facilities";

import FacilityAcceptMark from "@/pc/basics/FacilityAcceptMark.vue";

@Component({
  components: {
    FacilityAcceptMark
  }
})
export default class MedicalNursingsLabel extends Vue {
  @Prop()
  value!: MedicalNursings;

  get _value(): MedicalNursings {
    return this.value;
  }
}
</script>

<style lang="scss" scoped>
#medical-nursings-label {
  .medical-nursing-label {
    width: 280px;
  }
}
</style>
